// extracted by mini-css-extract-plugin
export var callCard = "_k5-0";
export var callMessageButton = "_k5-1";
export var helpIcon = "_k5-3";
export var helpIconContainer = "_k5-4";
export var verticalDivider = "_k5-2";